module.exports = __webpack_public_path__ + "assets/details-eur.3adfbb7d.svg";